import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="max-w-4xl mx-auto p-6 text-gray-800">
      <h1 className="text-3xl font-bold text-center mb-6">Privacy Policy</h1>
      {/* <p className="text-center text-gray-600 mb-8">
        Effective Date: 18 August 2025 <br />
        Website:{" "}
        <a href="https://www.surveysiq.com" className="text-green-600">
          www.surveysiq.com
        </a>
      </p> */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">1. Introduction</h2>
        <p>Welcome to SurveysIQ (“Company”, “we”, “our”, “us”).</p>
        <p>
          We are committed to protecting your privacy and ensuring that your
          personal information is collected, processed, and stored in compliance
          with the Information Technology Act, 2000, the Information Technology
          (Reasonable Security Practices and Procedures and Sensitive Personal
          Data or Information) Rules, 2011, and the Digital Personal Data
          Protection Act, 2023 (DPDP Act).
        </p>
        <p>
          This Privacy Policy explains how we collect, use, share, and safeguard
          your information when you use our services. By accessing or using
          SurveysIQ, you consent to the practices described in this Privacy
          Policy.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          2. Information We Collect
        </h2>
        <ul className="list-disc list-inside">
          <li>
            Personal Information: Name, email address, phone number, payment
            details (for rewards/withdrawals).
          </li>
          <li>Survey Data: Responses and feedback you provide in surveys.</li>
          <li>
            Device & Technical Data: IP address, browser type, operating system,
            and usage statistics.
          </li>
          <li>
            Referral Information: Details of referral activities and invite
            codes.
          </li>
          <li>
            Cookies & Tracking Data: Information about your browsing activity
            (see Section 5).
          </li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">3. Use of Information</h2>
        <ol className="list-decimal list-inside">
          <li>Provide access to surveys and process payments/rewards.</li>
          <li>Improve our services and enhance user experience.</li>
          <li>Verify identity and prevent fraud or misuse.</li>
          <li>Send notifications, updates, and promotional offers.</li>
          <li>Comply with applicable Indian laws and regulations.</li>
        </ol>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          4. Sharing of Information
        </h2>
        <p>
          We do not sell or rent your personal data. However, we may share
          information with:
        </p>
        <ul className="list-disc list-inside ml-6 mt-1">
          <li>
            Trusted service providers (payment processors, analytics, hosting
            services).
          </li>
          <li>
            Survey partners or research organizations (for survey-related
            purposes).
          </li>
          <li>
            Government authorities or regulators if required by Indian law.
          </li>
          <li>Third parties with your explicit consent.</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          5. Cookies & Tracking Technologies
        </h2>
        <p>We use cookies and similar technologies to:</p>
        <ul className="list-disc list-inside ml-6 mt-1">
          <li>Recognize repeat visitors.</li>
          <li>Store user preferences.</li>
          <li>Track performance and engagement.</li>
        </ul>
        <p>
          You may disable cookies in your browser settings, but some features of
          our service may not function properly.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">6. Analytics</h2>
        <p>
          We may use third-party analytics tools to monitor usage and improve
          services. These tools may collect information such as device details,
          session duration, and interactions, but not personally identifiable
          details unless you provide them.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">7. Payments</h2>
        <p>
          When you request withdrawals, we may collect and share payment-related
          information with payment processors and banking partners. We do not
          store sensitive financial information longer than necessary.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">8. Data Retention</h2>
        <p>
          We retain data only as long as necessary for providing services,
          fulfilling legal obligations, resolving disputes, or enforcing
          agreements, in compliance with Indian law.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">9. Security of Data</h2>
        <p>
          We follow reasonable security practices as per the IT Act, 2000 and
          DPDP Act, 2023. While we take strict measures to secure your
          information, no electronic storage or transmission method is
          completely secure.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">10. Children’s Privacy</h2>
        <p>
          Our services are not directed towards children under 18 years of age.
          If you are under 18, you may only use our services under the
          supervision of a parent/guardian.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">11. Your Rights</h2>
        <p>As per the DPDP Act, 2023, you have the right to:</p>
        <ul className="list-disc list-inside ml-6 mt-1">
          <li>Access and update your personal information.</li>
          <li>Withdraw consent for processing your data.</li>
          <li>
            Request deletion of your personal information (subject to legal
            obligations).
          </li>
          <li>File a grievance with our Grievance Officer.</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">12. Links to Other Sites</h2>
        <p>
          Our services may contain links to third-party websites. We are not
          responsible for the privacy practices or content of these external
          sites. We encourage you to read their privacy policies.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          13. Disclaimer of Liability
        </h2>
        <p>
          While we strive to secure your data, SurveysIQ is not liable for
          unauthorized access, hacking, or any loss of data beyond our
          reasonable control.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          14. Changes to This Privacy Policy
        </h2>
        <p>
          We may update this Privacy Policy periodically. Any changes will be
          posted on our website, and your continued use of the service will
          indicate acceptance of the updated terms.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">15. Grievance Officer</h2>
        <p>
          As per Indian IT Rules, 2021, we have appointed a Grievance Officer to
          address user complaints:
        </p>
        <p>Name: SurveysIQ Legal Team</p>
        <p>
          Email:
          <a href="mailto:help@surveysiq.com" className="text-green-600">
            {" "}
            help@surveysiq.com
          </a>
        </p>
        <p>Jurisdiction: Kolhapur, Maharashtra, India</p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          16. Governing Law & Jurisdiction
        </h2>
        <p>
          This Privacy Policy is governed by the laws of India, and any disputes
          shall be subject to the exclusive jurisdiction of the courts of
          Kolhapur, Maharashtra.
        </p>
      </section>
    </div>
  );
}
